import { createTypes } from 'redux-action-types'

export const types = createTypes('fridge/sheets/',
  'PUSH',
  'POP',
  'CLEAR',
  'SET'
)

export const push = (sheet) => ({type: types.PUSH, sheet})
export const set = (sheet) => ({type: types.SET, sheet})
export const pop = () => ({type: types.POP})
export const clear = () => ({type: types.CLEAR})



// WEBPACK FOOTER //
// ./app/actions/sheets.js